module.exports = __webpack_public_path__ + "img/logo-d-dot.71edec2d.svg";